import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'app/shared/services/api.service';
import { SessionStorageService } from 'app/shared/services/session-storage.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.scss','../../../../../../assets/sass/pages/page-users.scss']
})
export class ViewComponent implements OnInit {
  leadId:any;
  leadData:any
  imageUrl=environment.apiUrls.imageUrl;
  platform:any


  constructor(private apiService:ApiService,
              private activatedroute:ActivatedRoute,
              private session:SessionStorageService,
              private route: Router ) { 
      this.activatedroute.paramMap.subscribe(params => { 
      this.leadId = params.get('id');      
  });

  }

  ngOnInit(): void {
    this.getLeadById()
  }
  getLeadById(){
    this.apiService.getLeadsById(this.leadId).subscribe((res:any)=>{
      if(res.statusCode == 200){
        for(let item of res?.data){
          this.leadData=item
        }
      }
    })
  }
  edit(data){
    this.session.setObject('lead-data',data)
    this.route.navigate(['leads/edit',data._id])
  }
}

